function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { useFloating, flip, shift, offset, hide, useHover, useInteractions, safePolygon, useFocus } from '@floating-ui/react';
import { noop } from '@adsk/alloy-react-helpers';
import { useOverlay } from '@adsk/alloy-react-overlay';
import { getAllNestedKeys, getSelectedItems } from '../helpers/helpers';
const defaultOffset = {
  mainAxis: 0,
  crossAxis: -10
};
const reversedOffset = {
  mainAxis: 0,
  crossAxis: 10
};
const checkHasSelectedNested = (nested, value) => {
  if (!nested) {
    return false;
  }
  const allNestedKeys = getAllNestedKeys(nested);
  return allNestedKeys === null || allNestedKeys === void 0 ? void 0 : allNestedKeys.some(k => value.includes(k));
};
export default (_ref => {
  let {
    itemKey,
    placement: placementProp,
    disabled,
    value = [],
    nested,
    category,
    onClick: onClickProp,
    onChange = noop,
    onClose,
    safePolygonArgs = {
      enabled: true,
      // This blocks the hover events on adjacent items from triggering when moving the cursor to the nested menu
      // Without this, the safe triangle is not as effective
      blockPointerEvents: true
    }
  } = _ref;
  const [offsetValue, setOffsetValue] = useState(defaultOffset);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (placementProp !== useOverlay.PLACEMENTS.RIGHT_START) {
      setOffsetValue(reversedOffset);
    }
  }, [placementProp]);
  const {
    context,
    refs,
    floatingStyles
  } = useFloating({
    placement: placementProp,
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(offsetValue), flip(), shift(), hide()]
  });
  const enabledWithChildren = !disabled && !!nested;
  const focus = useFocus(context, {
    enabled: enabledWithChildren
  });
  const hover = useHover(context, {
    enabled: enabledWithChildren,
    handleClose: safePolygonArgs.enabled ? safePolygon(safePolygonArgs) : undefined
  });
  const interactions = useInteractions([focus, hover]);
  const selected = value.includes(itemKey);
  const hasSelectedNested = checkHasSelectedNested(nested, value);
  const handleClose = useCallback(cat => onClose && cat.showSelection === false && onClose(), [onClose]);
  const add = useCallback((eventKey, cat) => {
    onChange(getSelectedItems(value, eventKey, cat));
  }, [onChange, value]);
  const remove = useCallback(eventKey => {
    onChange(value.filter(k => k !== eventKey));
  }, [onChange, value]);
  const onClick = useCallback(e => {
    if (nested) {
      return;
    }
    if (onClickProp) {
      onClickProp(e);
    }
    if (!category) return;
    if (category.allowReselect) {
      add(itemKey, category);
    } else {
      if (selected) {
        remove(itemKey);
      } else {
        add(itemKey, category);
      }
    }
    handleClose(category);
  }, [add, category, handleClose, itemKey, nested, onClickProp, remove, selected]);
  const getOverlayMenuItemProps = useCallback(userProps => _objectSpread({}, interactions.getReferenceProps(_objectSpread(_objectSpread({}, userProps), {}, {
    onClick,
    selected: selected || hasSelectedNested,
    ref: refs.setReference
  }))), [hasSelectedNested, interactions, onClick, refs.setReference, selected]);
  const getNestedMenuProps = useCallback(userProps => interactions.getFloatingProps(_objectSpread(_objectSpread({}, userProps), {}, {
    ref: refs.setFloating,
    style: Object.assign(floatingStyles, userProps === null || userProps === void 0 ? void 0 : userProps.style),
    onClick: event => {
      var _userProps$onClick;
      event.stopPropagation();
      userProps === null || userProps === void 0 ? void 0 : (_userProps$onClick = userProps.onClick) === null || _userProps$onClick === void 0 ? void 0 : _userProps$onClick.call(userProps, event);
    }
  })), [floatingStyles, interactions, refs.setFloating]);
  return {
    getOverlayMenuItemProps,
    getNestedMenuProps,
    isOpen,
    selected
  };
});
//# sourceMappingURL=useOverlayMenuItem.js.map